import React, { useCallback } from 'react';
import { View } from 'react-native';
import {
  Banner,
  Button,
  Footer,
  Input,
  KeyboardScreenContainer,
  Text,
} from '~/components';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { isWeb } from '~/utils/device';
import type { StepComponentProps } from '~/components/StepsForm';
import { isCellPhone, isEmail } from '~/utils/yup';
import { useIncomeProtectionForm, useSalesFunnel } from '~/stores';

const schema = yup
  .object()
  .shape({
    email: isEmail(),
    cellphone: isCellPhone().required(
      'Insira as informações solicitadas acima'
    ),
  })
  .required();

const IncomeProtectionContractContact: React.FC<StepComponentProps> = ({
  onContinue,
}) => {
  const { setContact } = useIncomeProtectionForm();
  const { setInfos } = useSalesFunnel();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IncomeProtectionForm.Contact>({
    resolver: yupResolver(schema),
  });

  const onSubmit = useCallback(
    (data: IncomeProtectionForm.Contact) => {
      setContact(data);
      setInfos({
        email: data.email,
        cellphone: data.cellphone,
      });
      onContinue?.();
    },
    [onContinue, setContact, setInfos]
  );

  return (
    <KeyboardScreenContainer
      footer={
        <View className="flex xl:hidden">
          <Footer onSubmit={handleSubmit(onSubmit)} />
        </View>
      }
    >
      <View className="flex-1 container mx-auto xl:flex-row xl:pt-12 xl:pb-24">
        <Banner type="income-protection" />

        <View className="mt-8 xl:mt-0 px-6 flex-1 xl:ml-24">
          <Text className="text-xl text-gray-600 mb-8">E-mail e Celular</Text>

          <Input
            control={control}
            label="E-mail do segurado:"
            name="email"
            placeholder="Insira o e-mail do segurado"
            keyboardType="email-address"
            error={errors.email?.message}
            autoCapitalize="none"
            maxLength={100}
          />

          <Input
            control={control}
            name="cellphone"
            label="Celular do segurado com DDD"
            placeholder="DDD+Celular"
            error={errors.cellphone?.message}
            maskConfig={{ type: 'cel-phone' }}
            keyboardType="number-pad"
          />

          {isWeb && (
            <View className="flex-1 justify-end hidden xl:flex">
              <Button className="w-full" onPress={handleSubmit(onSubmit)}>
                CONTINUAR
              </Button>
            </View>
          )}
        </View>
      </View>
    </KeyboardScreenContainer>
  );
};

export default IncomeProtectionContractContact;
